<template>

	<div class="gray-bg" style="min-height: 100vh">

		<div class="middle-box text-center loginscreen   animated fadeInDown">
      <div>

        <div>
          <a target="_blank" href="https://www.snatchpark.com/parkbills/">
            <img src="/static/image/parkbills.png">
          </a>
          <img src="/static/image/park_bills_text_black.png">
        </div>
        
        <h3>Register to ParkBills</h3>
        
        <form class="m-t" role="form" action="login.html">
					
          <!--
					<div class="form-group">
						<input v-model="name" type="name" class="form-control" placeholder="Name" required="">
					</div>
          -->
					
					<div class="form-group">
						<input v-model="username" type="email" class="form-control" placeholder="Email" required="">
					</div>
					
          <!--
					<div class="form-group">
						<select v-model="type" v-on:change="onTypeChange" class="form-control" placeholder="Select Account Type" required="">
              <option value="" disabled selected>Select Account Type</option>
              <option value="company">Company</option>
              <option value="personal">Personal</option>
            </select>
					</div>

          <label class="form-control-feedback" >{{ typeRemark }} </label>
          <br>
          <br>
          -->

          <div class="form-group">
            <div class="checkbox i-checks">
              <label> 
                <input v-model="tnc" type="checkbox"><i></i> 
                I Agree to ParkBills' 
                <a v-bind:href="helper.WEB_URL + '/termsAndConditions'" target="parkbill_tnc">Terms of Use</a>
                &amp;
                <a v-bind:href="helper.WEB_URL + '/privacyPolicy'" target="parkbill_privacypolicy">Privacy Policy</a>
            </label>
            </div>
          </div>
          <br>

          <h3 class="smaller lighter grey" v-show="isLoading"><i class="fa fa-spin fa-spinner"></i></h3>

          <label class="error form-control-feedback" >{{ error }} </label>
          <label class="text-info form-control-feedback" >{{ result }} </label>
					
					<button type="submit" class="btn btn-primary block full-width m-b btn-snatch" @click.prevent="handleSubmit">
						Register
					</button>

          <p class="text-muted text-center"><small>Already have an account?</small></p>
          <a class="btn btn-sm btn-white btn-block" v-bind:href="helper.WEB_URL + '/login'">Login</a>
        </form>
				
				<p class="m-t">
					<small><strong>Copyright</strong> PARKAIDE &copy; 2018</small>
				</p>

      </div>
    </div>
    
  </div>

</template>

<script>
import helper from "@/components/Utility/Helper"
import validation from "@/components/Utility/Validation"

export default {
  name: "PageRegister",
  data(){
    return {
      helper: helper,

      name: '',
      username : '',
      type : '',
      typeRemark: '',
      tnc: null,
      isLoading: false,

      error : null,
      result  : null,
    }
  },
  mounted() {
    if(window.location.href.includes('localhost')) {
      document.title = 'Localhost';
    } else if(window.location.href.includes('parkbills.parkaidemobile.com')) {
      document.title = 'ParkBills Dev';
    } else if(window.location.href.includes('devpbills.parkaidemobile.com')) {
      document.title = 'ParkBills Dev';
    }
  },
  methods : {
    onTypeChange() {
      if(this.type === 'company') {
        this.typeRemark = 'For new application under personal name.';
      } else if(this.type === 'personal') {
        this.typeRemark = 'For new application under company name.';
      } else {
        this.typeRemark = '';
      }
    },
    handleSubmit(e){
      if(this.isLoading) {
        return;
      }
      
      // e.preventDefault();
      if (!this.username || this.username.trim().length === 0) {// && this.type.length > 0) {
        this.error = 'Please fill in required info before proceed.';
        return;
      }

      let error = validation.validateEmail(this.username)
      if (error) {
        this.error = error;
        return;
      }

      if (!this.tnc) {
        this.error = 'Please agree to Terms and Conditions & Privacy Policy before proceed';
        return;
      }

      this.error = '';
      this.result = '';
      this.isLoading = true;
      this.$http
        .post(helper.API_URL + '/api2/auth2/web/register', {
          email: this.username,
          type: this.type,
          parkbill: 1,
        })
        .then(response => {
          this.isLoading = false;
          let resultMeta = helper.processAxiosResponse(this, response);
          this.result = `Further instructions have been sent to your e-mail ${this.username}.`;
          
          let data = response.data;
          // if(data.passwordLink) {
          //   if(window.location.href.includes('localhost')) {
          //     window.open('verifyRegister?email=' + encodeURIComponent(data.email) + '&link=' + encodeURIComponent(data.passwordLink), "_blank");
          //   }
          // }

          helper.redirect(helper.WEB_URL + '/login', 3000);
        })
        .catch((error) => {
          this.isLoading = false;
          this.error = 'Problem registering account. ' + this.parseLoginError(error);
        });
    },
    parseLoginError(error) {
      if(error) {
        if(error.response) {
          if(error.response.data) {
            if(error.response.data.message) {
              return error.response.data.message;
            }

            if(typeof a_string === 'string') {
              return error.response.data;
            }
          }

          if(typeof a_string === 'string') {
            return error.response;
          }
        }
      }

      return 'Please try again.'
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Page/User/PageRegister.vue